var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gemmologist',{attrs:{"staff-type":2,"staff-type-name":"辅助人员"}})
}
var staticRenderFns = []

export { render, staticRenderFns }